module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('image-form', {
    attrs: {
      "create": true
    },
    on: {
      "saved": _vm.gotoImage
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Uploading a new image")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05746b43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/images/ImageCreate.vue
// module id = 495
// module chunks = 0